<div [attr.class]="classes">
  <div class="arrow"></div>
  <div class="tooltip-content" role="tooltip">
    <ng-template #default let-options="options">
      <div class="popover-body" cdkFocusInitial>
        {{ tooltipMessage }}
      </div>
    </ng-template>

    <ng-template
      [ngTemplateOutlet]="templateRef || default"
      [ngTemplateOutletContext]="{ tooltipMessage: tooltipMessage }"
    >
    </ng-template>
  </div>
</div>
